import { ReactNode, createContext, useContext } from 'react'

import { SearchDetailResult } from 'interface/search'
import { TargetListResult } from 'interface/search/targetList'
import { MrpProjectResult } from 'interface/carenet/mrp'
import { LvProjectResult } from 'interface/carenet/lv'
import { EvaluationFormResult } from 'interface/evaluationForm'

const SearchContext = createContext<SearchDetailResult | null>(null)
export const useSearch = () => useContext(SearchContext)

const EvaluationFormContext = createContext<EvaluationFormResult | null>(null)
export const useEvaluationForm = () => useContext(EvaluationFormContext)

const TargetListContext = createContext<TargetListResult | null>(null)
export const useTargetList = () => useContext(TargetListContext)

const MrpProjectContext = createContext<MrpProjectResult | null>(null)
export const useMrpProject = () => useContext(MrpProjectContext)

const LvProjectContext = createContext<LvProjectResult | null>(null)
export const useLvProject = () => useContext(LvProjectContext)

type SearchProviderProps = {
  search: SearchDetailResult | null
  evaluationForm?: EvaluationFormResult | null
  targetList?: TargetListResult | null
  mrpProject?: MrpProjectResult | null
  lvProject?: LvProjectResult | null
  children: ReactNode
}
export const SearchProvider = ({
  search,
  evaluationForm,
  targetList,
  mrpProject,
  lvProject,
  children
}: SearchProviderProps) => {
  return (
    <SearchContext.Provider value={search}>
      <EvaluationFormContext.Provider value={evaluationForm ?? null}>
        {targetList ? (
          <TargetListContext.Provider value={targetList}>{children}</TargetListContext.Provider>
        ) : mrpProject ? (
          <MrpProjectContext.Provider value={mrpProject}>{children}</MrpProjectContext.Provider>
        ) : lvProject ? (
          <LvProjectContext.Provider value={lvProject}>{children}</LvProjectContext.Provider>
        ) : (
          children
        )}
      </EvaluationFormContext.Provider>
    </SearchContext.Provider>
  )
}
